import { TourCompletionState, TourStorage } from './types';

function safeParse(value: string | null): TourCompletionState {
  if (!value) {
    return {};
  }
  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === 'object') {
      return parsed as TourCompletionState;
    }
  } catch {
    // ignore malformed data
  }
  return {};
}

export function createLocalStorageTourStorage(key = 'ui.tours.state'): TourStorage {
  return {
    async read() {
      if (typeof window === 'undefined') {
        return {};
      }
      return safeParse(window.localStorage.getItem(key));
    },
    async write(state) {
      if (typeof window === 'undefined') {
        return;
      }
      try {
        window.localStorage.setItem(key, JSON.stringify(state));
      } catch {
        // ignore quota failures
      }
    }
  };
}

export function createMemoryTourStorage(initial?: TourCompletionState): TourStorage {
  let state = initial ?? {};
  return {
    async read() {
      return state;
    },
    async write(next) {
      state = { ...next };
    }
  };
}
